import React, { useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { useAppContext } from '../../AppContext';
import { useTranslation } from 'react-i18next';

const BugReportView = () => {
    const { t } = useTranslation();
    const { appFunctions, setMessage } = useAppContext();
    const [report, setReport] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (report.trim().length < 10) {
            setMessage(t('settings.bugReport.tooShort'));
            return;
        }
        setIsSubmitting(true);
        try {
            const submitBugReport = httpsCallable(appFunctions, 'submitBugReport');
            await submitBugReport({ report });
            setMessage(t('settings.bugReport.submitSuccess'));
            setReport('');
        } catch (error) {
            setMessage(t('settings.bugReport.submitError', { message: error.message }));
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="bg-black/20 backdrop-blur-md rounded-2xl p-6 border border-slate-700/50">
            <h2 className="text-3xl font-bold font-playfair mb-2 text-orange-300">{t('settings.bugReport.title')}</h2>
            <p className="mb-6 text-gray-400">{t('settings.bugReport.description')}</p>

            <form onSubmit={handleSubmit}>
                <textarea
                    value={report}
                    onChange={(e) => setReport(e.target.value)}
                    placeholder={t('settings.bugReport.placeholder')}
                    className="w-full h-40 p-3 bg-slate-800/50 rounded-md text-white border border-slate-700/50 focus:ring-2 focus:ring-orange-500 focus:outline-none"
                    required
                />
                <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full mt-4 bg-orange-600 hover:bg-orange-700 text-white font-bold py-3 px-4 rounded-lg transition duration-300 disabled:opacity-50 shadow-lg hover:shadow-orange-500/50"
                >
                    {isSubmitting ? t('settings.bugReport.sending') : t('settings.bugReport.submit')}
                </button>
            </form>
        </div>
    );
};

export default BugReportView;